import React, { memo } from 'react';
import { Icon } from '@iconify/react';
import './TableActionButton.css';

const DEFAULT_ICONS = {
  view: 'mdi:eye-outline',
  add: 'mdi:plus-circle-outline',
  edit: 'mdi:pencil-outline',
  delete: 'mdi:trash-can-outline',
  navigate: 'ion:navigate-circle-outline',
};

const TableActionButton = ({
  actionType = 'view',
  icon,
  label,
  disabled,
  loading,
  title,
  onClick,
  buttonProps = {}, // ✅ custom styles from table header
  rowId,
  actionKey
}) => {
  const { className = '', style = {}, iconStyle = {}, iconClassName = '' } = buttonProps || {};

  const finalIcon = icon || DEFAULT_ICONS[actionType] || 'mdi:gesture-tap';

  return (
    <button
      type="button"
      className={`table-action-btn action-${actionType} ${className}`}
      style={style}
      disabled={disabled || loading}
      title={title || ''}
    //   onClick={onClick}
      data-actionkey={actionKey}
      data-rowid={rowId}
      data-actiontype={actionType}
    >
      <Icon icon={finalIcon} className={`table-action-icon ${iconClassName}`} style={iconStyle} />

      {/* optional label */}
      {label ? <span className="table-action-label">{label}</span> : null}
    </button>
  );
};

export default memo(TableActionButton);
